'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { AnimatePresence, motion } from 'framer-motion';
import { useEffect, useRef } from 'react';
import { RecentSearchChips } from './RecentSearchChips';
import { SearchBar } from './SearchBar';
interface HeaderSearchOverlayProps {
  isOpen: boolean;
  keyword?: string;
  onClose: () => void;
  onSearch: (keyword: string) => void;
  recentKeywords: string[];
  onSelectRecent: (keyword: string) => void;
  onRemoveRecent: (keyword: string) => void;
  onClearRecent: () => void;
  /** xl 이상에서 검색바/chips 영역의 최대 폭. 검색 페이지의 카테고리별 폭과 정렬된다. */
  searchBarMaxWClass?: string;
}
export function HeaderSearchOverlay(t0) {
  const $ = _c(19);
  const {
    isOpen,
    keyword,
    onClose,
    onSearch,
    recentKeywords,
    onSelectRecent,
    onRemoveRecent,
    onClearRecent,
    searchBarMaxWClass
  } = t0;
  const overlayRef = useRef(null);
  let t1;
  let t2;
  if ($[0] !== isOpen || $[1] !== onClose) {
    t1 = () => {
      if (!isOpen) {
        return;
      }
      const handleUserScroll = () => onClose();
      window.addEventListener("wheel", handleUserScroll, {
        passive: true
      });
      window.addEventListener("touchmove", handleUserScroll, {
        passive: true
      });
      return () => {
        window.removeEventListener("wheel", handleUserScroll);
        window.removeEventListener("touchmove", handleUserScroll);
      };
    };
    t2 = [isOpen, onClose];
    $[0] = isOpen;
    $[1] = onClose;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[4] !== isOpen || $[5] !== onClose) {
    t3 = () => {
      if (!isOpen) {
        return;
      }
      const handleOutsideClick = e => {
        const target = e.target as Element | null;
        if (!target) {
          return;
        }
        const header = overlayRef.current?.closest("header");
        if (header?.contains(target)) {
          return;
        }
        if (target.closest("[role=\"menu\"],[role=\"listbox\"],[role=\"dialog\"],[data-radix-popper-content-wrapper]")) {
          return;
        }
        onClose();
      };
      document.addEventListener("mousedown", handleOutsideClick);
      return () => {
        document.removeEventListener("mousedown", handleOutsideClick);
      };
    };
    t4 = [isOpen, onClose];
    $[4] = isOpen;
    $[5] = onClose;
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  useEffect(t3, t4);
  let t5;
  if ($[8] !== isOpen || $[9] !== keyword || $[10] !== onClearRecent || $[11] !== onRemoveRecent || $[12] !== onSearch || $[13] !== onSelectRecent || $[14] !== recentKeywords || $[15] !== searchBarMaxWClass) {
    t5 = isOpen && <motion.div ref={overlayRef} key="header-search-overlay" initial={{
      height: 0
    }} animate={{
      height: "auto"
    }} exit={{
      height: 0
    }} transition={{
      duration: 0.25,
      ease: [0.22, 1, 0.36, 1]
    }} className="absolute inset-x-0 top-full z-10 overflow-hidden border-b border-Gray-200 bg-Gray-white"><div className="mx-auto flex max-w-screen-xl flex-col items-center px-40 pb-20 pt-12"><div className={cn("flex w-full flex-col items-center gap-12", searchBarMaxWClass)}><SearchBar keyword={keyword} shouldAutoFocus={isOpen} sticky={false} onSearch={onSearch} />{recentKeywords.length > 0 && <RecentSearchChips keywords={recentKeywords} onSelect={onSelectRecent} onRemove={onRemoveRecent} onClearAll={onClearRecent} />}</div></div></motion.div>;
    $[8] = isOpen;
    $[9] = keyword;
    $[10] = onClearRecent;
    $[11] = onRemoveRecent;
    $[12] = onSearch;
    $[13] = onSelectRecent;
    $[14] = recentKeywords;
    $[15] = searchBarMaxWClass;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== t5) {
    t6 = <AnimatePresence initial={false}>{t5}</AnimatePresence>;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
}